package core.enums

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 11.10.22
 * Author : mariorosshirt
 */
enum class ELocalizationKeys() {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    S01_SLIDER_TITLE,

    S01_TITLE_1,

    S01_TEXT_1,

    S01_TITLE_2,

    S01_TEXT_2,

    S01_MY_COLOR_PREVIEW_TITLE,

    S01_TITLE_3,

    S01_TEXT_3,

    S01_TITLE_4,

    S01_TEXT_4,

    S01_PRODUCT_LIST_TITLE,

    S01_BUTTON_CONTENT,

    S01_BUTTON_NEXT,

    S01_BUTTON_BACK,

    S01_BUTTON_SKIP,

    S02_TITLE_1,

    S02_TEXT_1,

    S02_BUTTON_CONTENT_TAKE_PICTURE,

    S02_SHOW_COLOURWALL_NATIVE_APP_BUTTON_TITLE,

    S03_PRIMARY_BUTTON_CONTENT,

    S04_PRIMARY_ACTION_BUTTON_CONTENT,

    S04_PRIMARY_NAVIGATION_BUTTON_CONTENT,

    S04_OWN_COLOURS_HEADER,

    S04_SUGGESTED_COLOURS_HEADER,

    S04_DELETE_CONFIRMATION_TEXT,

    S10_PRIMARY_BUTTON_CONTENT,

    S10_HEADER,

    S10_DELETE_CONFIRMATION_TEXT,

    S06_TEXT_1,

    S06_TITLE_1,

    S06_BUTTON_CONTENT_EXAMPLEROOMS,

    MENU_TITLE_IMPRINT,

    MENU_TITLE_INTEGRITY,

    MENU_TITLE_PRIVACY,

    MENU_TITLE_SETTINGS,

    MENU_TITLE_PRODUCTLIST,

    MENU_TITLE_WATCHLIST,

    MENU_TITLE_RESTART,

    MENU_TITLE_RETAILER_SEARCH,

    MENU_TITLE_RESTART_TOUR,

    MENU_NOTE_COLOR_ACCURACY_TITLE,

    MENU_NOTE_COLOR_ACCURACY_TEXT,

    S04_FIXED_LIST_EMPTY_TITLE,

    S04_FIXED_LIST_EMPTY_TEXT,

    S04_FIXED_LIST_EMPTY_BUTTON_CONTENT,

    S05_PRODUCT_LIST_HEADER,

    S05_DELETE_CONFIRMATION_TEXT,

    S05_NO_EAN_ALERT_TEXT,

    S05_PRODUCT_LIST_HINT_TITLE,

    S05_PRODUCT_LIST_HINT_TEXT,

    S05_PRODUCT_LIST_NEEDED_AMOUNT,

    S05_PRODUCT_LIST_NEEDED_AMOUNT_UNIT,

    S05_PRODUCT_LIST_TEXT_PLACEHOLDER,

    S05_QUESTION_MARK_TEXT,

    S05_PRODUCT_LIST_EMPTY_TITLE,

    S05_PRODUCT_LIST_EMPTY_TEXT,

    S05_PRODUCT_LIST_EMPTY_BUTTON_CONTENT,

    S05_PRIMARY_BUTTON_CONTENT,

    S10_WATCH_LIST_EMPTY_TITLE,

    S10_WATCH_LIST_EMPTY_TEXT,

    S10_WATCH_LIST_EMPTY_BUTTON_CONTENT,

    S10_SHOW_ON_WALL_BUTTON_CONTENT,

    S102_SHOW_ON_WALL_BUTTON_CONTENT,

    S102_DESELCT_ALL_BUTTON_CONTENT,

    S102_HEADER_EMPTY_LIST,

    S102_MAX_COLOURS_SELECTED_CONTENT,

    SETTINGS_USAGE_ANALYSIS_TITLE,

    SETTINGS_COOKIE_SETTING_TITLE,

    CORE_BACK,

    CORE_TOAST_ADD_TO_WATCH_LIST,

    CORE_TOAST_DELETE_FROM_WATCH_LIST,

    CORE_TOAST_ADD_TO_PRODUCT_LIST,

    CORE_TOAST_DELETE_FROM_PRODUCT_LIST,

    CORE_TOAST_DELETE_FROM_FIXED_OR_SUGGESTED_LIST,

    CORE_TOAST_SAVE_PICTURE_SUCCESSFULLY,

    CORE_TOAST_NO_COLOUR_HIGHLIGHTED,

    EXPORT_FILENAME_WATCHLIST,

    EXPORT_FILENAME_PRODUCTLIST,

    SHOW_LIVE_BUTTON,

    RETAIL_SEARCH_URL,

    RETAIL_BUTTON_TITLE,

    OK,

    CANCEL,

    BUY_OPTIONS,

    BUY_OPTIONS_URL,

    USAGE_ANALYSIS_TEXT,

    INTEGRITY_CONTENT,

    ALERT_MESSAGE_NO_INTERNET_CONNECTION,

    ALERT_MESSAGE_CONNECT_TIMEOUT,

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}